export default __webpack_public_path__ + "static/media/Download_report.e9b6d620.svg";